<template>
  <div class="col-12 mx-auto">
      <!-- search panel centered to 30% -->
      <div class="overlay" @click="showSearchResults = false" v-if="showSearchResults"></div>
      <div class="col-md-12 m-0 p-0" style="z-index:99">
        <div>
          <b-input-group size="md" class="">
            <b-form-input type="text"
            class="searchInput"
              v-model="searchString"
              v-on:keyup.enter="lookForAllSearchedToggle"
              placeholder="search customer name, phone, etc">
            </b-form-input>
            <b-input-group-append v-if="showSearchResults">
              <b-input-group-text @click="reset">
                <b-icon variant="primary" icon="x" />
              </b-input-group-text>
            </b-input-group-append>
            <b-input-group-append v-if="loading">
              <b-input-group-text>
                <b-spinner small></b-spinner>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        <!-- search result container below search panel -->
        <div class="searchResultContainer shadow-sm p-2 col-md-12" v-if="showSearchResults">
          <div v-if="customerSearchResult.length > 0">
            <div
              v-on:click="openProfile(data.id, data.mobile)"
              v-for="(data, index) in customerSearchResult"
              :key="index"
              class="searchResults mb-2 m-0 p-2 col-md-12"
            >
              <b-row>
                <b-col md="8">
                  <p class="m-0 p-0">
                    <strong>{{ data.name || 'Anonymous'}}</strong>
                  </p>
                </b-col>
                <b-col class="text-right">
                  <b-badge v-if="data.status == 1" pill variant="primary"
                    >Active</b-badge
                  >
                  <b-badge v-else pill variant="danger">Inactive</b-badge>
                </b-col>
              </b-row>
              <div class="">
                    <p class="p-0 my-0 mr-2 text-truncate">{{ data.email || '-'}}, </p>
                    <p class="p-0 my-0 mr-2">{{data.mobile || 'NA'}}</p>
                  </div>
            </div>
          </div>
          <div v-else>
            <div
              v-if="searchString.length > 0 && !loading"
              class="mb-2 m-0 p-2"
            >
              <b-row class="p-2 text-dark">
                <p style="font-size:12px" class="text-muted">No matching search results for "{{ searchString }}"</p>
              </b-row>
            </div>
          </div>
        </div>
        <!-- end of search panel -->
      </div>
    </div>
     <b-modal scrollable hide-footer v-model="lookForAllSearched" :title="`All Search Results for '${searchString}'`" size="lg">
          <div class="col-6 m-0 p-0 sticky">
            <p class="label text-muted">{{allCustomers.length}} search results found.</p>
            <input v-model="searchOnResult" type="text" class="form-control" placeholder="search within searched results">
          </div>
          <div class="col-12 my-4">
            <b-row>
              <b-col class="p-2 pb-0 col-4 m-0" v-for="(data, index) in filteredResultsList" :key="index">
                <b-card :border-variant="data.status == 1 ? 'success' : 'danger'" v-on:click="openProfile(data.id, data.mobile)" class="m-0 p-0 searchResults">
                  <div class="m-0 p-0 mb-2">
                    <b-badge v-if="data.status == 1" pill variant="primary"
                      >Active</b-badge
                    >
                    <b-badge v-else pill variant="danger">Inactive</b-badge>
                  </div>
                  <h6 class="m-0 p-0">{{data.name}}</h6>
                  <p class="m-0 p-0">{{data.email}}</p>
                  <p class="m-0 p-0">{{data.mobile}}</p>
                  <div>
                    <p class="text-muted m-0 p-0 mt-2" style="font-size:12px">
                      Customer from {{data.createdAt | moment("ll")}}
                    </p>
                  </div>
                </b-card>
              </b-col>
            </b-row>
          </div>
      </b-modal>
  </div>
</template>

<script>
import * as _ from "lodash";
export default {
  watch: {
    async searchString() {
      if(this.searchString.length > 0) {
        try {
        this.loading = true;
        await this.$store.dispatch("searchSEO", { phone: this.searchString });
        this.showSearchResults = true
      } catch {
        this.$toasted.global.my_app_error();
      } finally {
        this.loading = false;
      }
      }
    },
    showSearchResults(newVal) {
      newVal ? document.body.classList.add('modal-open') : document.body.classList.remove('modal-open')
    }
  },
  data() {
    return {
      searchString: "",
      loading: false,
      searchOnResult: '',
      showSearchResults: false,
      lookForAllSearched: false
    };
  },
  created() {},
  methods: {
    lookForAllSearchedToggle() {
      this.showSearchResults = false
      this.lookForAllSearched = true
    },
    openProfile(id, mobile) {
      let route = this.$router.resolve({ path: "/userProfile/" + id + "/" + mobile });
      window.open(route.href, '_blank');
      this.reset()
    },
    reset() {
      this.searchString = ''
      this.showSearchResults = false
    }
  },
  computed: {
    allCustomers() {
      return _.orderBy(this.$store.state.searchSEO,
        "status",
        "desc"
      );
    },
    filteredResultsList() {
      return this.allCustomers.filter((post) => {
        if (post.name && post.mobile && post.email) {
          return (
            post.name.toLowerCase().includes(this.searchOnResult.toLowerCase()) ||
            post.mobile.toString().includes(this.searchOnResult.toLowerCase()) ||
            post.email.toLowerCase().includes(this.searchOnResult.toLowerCase())
          );
        }
      });
    },
    customerSearchResult() {
      return _.orderBy(
        _.slice(this.$store.state.searchSEO, [0], [5]),
        "status",
        "desc"
      );
    },
  },
};
</script>

<style scoped>
.sarchPanelContainer {
  height: 85vh;
  width: 100%;
  position: relative;
  background-image: url("https://pa.media/wp-content/uploads/2019/05/NEW-BRAND-ILLUSTRATIONS-04-1.png");
  background-size: cover;
  background-position: 90% 0%;
  background-size: 200px;
  background-repeat: no-repeat;
  background-blend-mode: darken;
  overflow: scroll;
}
.searchPanel {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.searchResultContainer {
  background: #fafafa;
  position: absolute;
  top: 100%;
  width: 100%;
  z-index: 9999
}
.searchResults {
  background: #eaebf8;
  font-size: 12px;
  cursor: pointer;
  color: black;
}
.searchResults:hover {
  background: #f1f4f8;
  color: #4249c0;
}
.form-control:focus {
  box-shadow: none;
  outline: none !important;
}
.searchInput{
  border-radius: 5px;
  font-size: 12px;
  font-weight: 300;
  box-shadow: none;
  outline: none;
}
.overlay{
  background: rgb(0, 0, 0, 0.5);
  height: 100vh;
  overflow: hidden;
  width: 500%;
  position: fixed;
  z-index: 98;
  top: 0;
  left: 0;
}
</style>
